import React from 'react';
import { Card } from '@/components/ui';
import { Clock } from 'lucide-react';

export function RecentUserActivities() {
  const activities = [
    { title: 'Nguyễn Văn A xin nghỉ phép', context: 'Phòng Kỹ thuật', time: '10 phút trước', type: 'leave' },
    { title: 'Cập nhật bảng lương T04', context: 'Hệ thống', time: '1 giờ trước', type: 'salary' },
    { title: 'Tuyển dụng 5 công nhân mới', context: 'Dự án Eco Garden', time: 'Hôm qua, 14:30', type: 'recruit' },
    { title: 'Thay đổi quyền quản trị', context: 'Admin -> Manager', time: '12/05/2026', type: 'permission' }
  ];

  return (
    <Card className="bg-white border-2 border-slate-100 shadow-sm rounded-md p-5 h-full flex flex-col">
      <div className="flex-1 relative">
        <div className="absolute top-6 bottom-6 left-[9px] w-[2px] bg-slate-100" />

        <div className="space-y-4 relative z-10">
          {activities.slice(0, 4).map((activity, i) => (
            <div key={i} className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-3 flex items-center justify-center w-5 h-5 rounded-full bg-white border-[3px] border-blue-500 shadow-[0_0_0_4px_white]">
              </div>

              <div className="flex-1 p-3.5 rounded-xl border border-slate-100 bg-white shadow-sm hover:border-blue-200 hover:shadow-md transition-all">
                <h4 className="text-sm font-black text-slate-800 mb-1.5">{activity.title}</h4>
                <p className="text-xs text-slate-500 mb-2.5">{activity.context}</p>
                <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-slate-50 text-slate-500 text-xs font-medium border border-slate-100">
                  <Clock className="w-3.5 h-3.5 opacity-70" />
                  <span>{activity.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
